import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as MdIcons from 'react-icons/md';

const { MdGraphicEq, MdNotifications, MdSettings } = MdIcons;

const Header = ({ onSettingsClick }) => {
  return (
    <header className="sticky top-0 z-50 flex items-center justify-between whitespace-nowrap border-b border-solid border-slate-200 dark:border-border-dark bg-background-light/80 dark:bg-background-dark/80 backdrop-blur-md px-6 lg:px-10 py-4">
      <div className="flex items-center gap-4">
        <div className="flex items-center justify-center w-10 h-10 rounded-full bg-primary/10 text-primary">
          <SafeIcon icon={MdGraphicEq} className="text-2xl" />
        </div>
        <h2 className="text-lg lg:text-xl font-bold leading-tight tracking-tight text-slate-900 dark:text-white">
          AI YouTube Studio
        </h2>
      </div>
      
      <div className="hidden md:flex flex-1 items-center justify-center px-8">
        <nav className="flex items-center gap-8">
          <span className="px-4 py-2 bg-primary/10 text-primary rounded-full text-sm font-bold">
            Generator
          </span>
        </nav>
      </div>

      <div className="flex items-center gap-4">
        <button 
          onClick={onSettingsClick}
          className="flex items-center justify-center rounded-full w-10 h-10 bg-slate-200 dark:bg-surface-dark hover:bg-slate-300 dark:hover:bg-border-dark transition-colors text-slate-600 dark:text-white"
          title="Settings"
        >
          <SafeIcon icon={MdSettings} className="text-xl" />
        </button>
        
        <button className="flex items-center justify-center rounded-full w-10 h-10 bg-slate-200 dark:bg-surface-dark hover:bg-slate-300 dark:hover:bg-border-dark transition-colors text-slate-600 dark:text-white">
          <SafeIcon icon={MdNotifications} className="text-xl" />
        </button>
        
        <button className="flex items-center gap-2 pl-1 pr-4 py-1 bg-slate-200 dark:bg-surface-dark rounded-full hover:bg-slate-300 dark:hover:bg-border-dark transition-colors">
          <div className="w-8 h-8 rounded-full bg-primary flex items-center justify-center text-white font-bold text-xs">
            JD
          </div>
          <span className="text-sm font-medium hidden sm:block text-slate-900 dark:text-white">Profile</span>
        </button>
      </div>
    </header>
  );
};

export default Header;